import { message } from "antd";
import { downloadPDF, formatDate, token } from "../../../../../config/globleData";
import { api } from "../../../../../config/api";
import { Link } from "react-router-dom";

export const pharmacyColumn = [
  // {
  //   title: "Sr No.",
  //   key: "srNo",
  //   render: (text, record, index) =>
  //     (currentPage - 1) * entriesPerPage + index + 1,
  //   align: "center",
  // },
  {
    title: "Registered Company",
    dataIndex: "RegisteredCompanyName",
    key: "RegisteredCompanyName",
    render: (text, record) => (
      <div>
        <Link style={{ color: "#408dfb" }} to={`/admin/pharmacy-list/${record._id}`}>
          {record.RegisteredCompanyName}
        </Link>
      </div>
    ),
    sorter: (a, b) =>
      a.RegisteredCompanyName?.localeCompare(b.RegisteredCompanyName),
    align: "center",
  },
  {
    title: "Trading Name",
    dataIndex: "Tradingname",
    key: "Tradingname",
    sorter: (a, b) => a.Tradingname?.localeCompare(b.Tradingname),
    align: "center",
  },
  {
    title: "Email",
    dataIndex: "businessEmail",
    key: "businessEmail",
    sorter: (a, b) => a.businessEmail?.localeCompare(b.businessEmail),
    align: "center",
  },
  {
    title: "Date Registered",
    key: "dateRegistered",
    render: (text, record) => <div>{formatDate(record.completionDate)}</div>,
    sorter: (a, b) => new Date(a.completionDate) - new Date(b.completionDate),
    align: "center",
  },
  {
    title: "Action",
    key: "action",
    render: (text) => (
      <div>
        <span
          onClick={() => {
            message.open({
              type: "loading",
              content: "Wait for the download of Pharmacy Registration",
            });
            downloadPDF(
              `${api.pharmacyRegistrationsList}/${text._id}/download`,
              `Pharmacy_Registration_${text._id}.pdf`,
              token
            ).finally(() => {
              setTimeout(() => {
                message.open({
                  type: "success",
                  content: "Downloaded Successfully",
                  duration: 2,
                });
              }, 1000);
            });
          }}
          style={{ cursor: "pointer", marginRight: "8px" }}
        >
          <span style={{ color: "#408dfb" }}>Download</span>
          {/* <i className="fa fa-file-pdf-o" aria-hidden="true"></i> */}
        </span>
        {/* <Link to={`/admin/pharmacy-list/${text._id}`}>
          <i className="fa fa-eye"></i>
        </Link> */}
      </div>
    ),
    align: "center",
  },
];
